import React from 'react';

import firebase from './../../firebase';

class PetitionForm extends React.Component {
    
    state = {
        value: {
            first_name: '',
            last_name: '',
            organization: '',
            city: '',
        },
        confirmedTerms: false,
        error: null,
        success: false,
        saving: false,
    }

    onChange = (e) => {
        let value = this.state.value;
        value[e.target.name] = e.target.value;
        this.setState({value});
    }

    onChangeCheckbox = (e) => {
        this.setState({confirmedTerms: !this.state.confirmedTerms});
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({error: null, saving: true, success: false});

        if(!validate(this.state.value)) {
            this.setState({error: 'Var god fyll i alla obligatoriska fält', saving: false});
            console.error('Validation failed');
            return;
        }

        if (!this.state.confirmedTerms) {
            this.setState({error: 'Var god godkänn villkoren', saving: false});
            console.error('Need to confirm terms');
            return;
        }

        let value = {...this.state.value, createdAt: new Date().getTime()};
        firebase.collection('petition').add(value).then(() => {
            console.log('Success writing document');
            const emptyValue = {
                first_name: '',
                last_name: '',
                organization: '',
                city: '',
            };
            this.setState({value: emptyValue, confirmedTerms: false, saving: false, success: true, error: null});
        }).catch((error) => {
            this.setState({error: 'Ett oväntat fel inträffade, var god försök igen eller kontakta info@foodpharmacy.se', saving: false});
            console.error('Error writing document: ', error);
        });
    }

    render() {
        return(
            <div className="petition-form">
                <form onSubmit={this.onSubmit}>
                    {this.state.success && <div className="petition-overlay">
                        <div className="petition-overlay-content">
                            <div>Namn inskickat. Tack för ditt stöd!</div>
                            <div><p className="success"><span onClick={() => {this.setState({success: false})}}>Tillbaka</span></p></div>
                        </div>
                    </div>}
                    <div><input placeholder="Förnamn (obligatoriskt)" type="text" value={this.state.value.first_name} name="first_name" onChange={this.onChange} /></div>
                    <div><input placeholder="Efternamn (obligatoriskt)" type="text" value={this.state.value.last_name} name="last_name" onChange={this.onChange} /></div>
                    <div><input placeholder="Befattning / Organisation" type="text" value={this.state.value.organization} name="organization" onChange={this.onChange} /></div>
                    <div><input placeholder="Stad (obligatoriskt)" type="text" value={this.state.value.city} name="city" onChange={this.onChange} /></div>

                    <div>
                        <label className="checkbox-container">
                            <input type="checkbox" checked={this.state.confirmedTerms} onChange={this.onChangeCheckbox} />
                            <span className="checkmark"></span>
                            Jag samtycker till att mitt namn visas i sammanhang kopplade till denna namninsamling. Mina namnuppgifter kommer inte att användas i annat syfte än att visa att jag stödjer denna sakfråga. Läs hela vår <a target="_blank" href="https://foodpharmacy.se/integritetspolicy/">integritetspolicy här.</a> 
                        </label>
                    </div>

                    {this.state.error && <p className="error">{this.state.error}</p>}

                    <div><button className="petition-submit" type="submit">{this.state.saving ? 'Skickar...' : 'Skriv under'}</button></div>
                </form>
            </div>
        );
    }
}

function validate(input) {
    if (input.first_name === '' || input.last_name === '') {
        return false;
    }

    return true;
}

export default PetitionForm;


// WEBPACK FOOTER //
// ./src/components/petition/PetitionForm.js